import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/salesPerson",
    name: "salesPerson",
    component: dashboard,
    redirect: {
      name: "salesPersonIndex"
    },
    children: [
      {
        path: "salesPersonIndex",
        name: "salesPersonIndex",
        meta: { title: "工贸售后人员管理" },
        component: () => import("@/views/salePerson/salePerson.vue"),
        children: [
          {
            path: "editSalesPersonInfo/:afterSalePersonId",
            name: "editSalesPersonInfo",
            meta: { title: "售后人员信息维护" },
            component: () => import("@/views/salePerson/salePersonManage.vue")
          },
          {
            path: "addSalesPersonInfo",
            name: "addSalesPersonInfo",
            meta: { title: "添加售后服务人员" },
            component: () => import("@/views/salePerson/addSalePerson.vue")
          }
        ]
      }
    ]
  }
];
